// Constants
import * as Constants from "../../constants";

// Helpers
import DB from "../../helpers/db";

import { TOKENREFRESH } from "../definitions";

export const refershToken = (id) => async (dispatch) => {
  try {
    dispatch({
      type: TOKENREFRESH.START_REFRESH_TOKEN,
    });
    await DB({
      method: Constants.EMPTY,
      url: `/refreshtoken`,
    }).then((response) => {
      if (response?.data) {
        document.cookie = response?.data?.data;
        dispatch({
          type: TOKENREFRESH.REFRESH_TOKEN_SUCCESS,
          payload: response.data,
        });
      }
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: TOKENREFRESH.REFRESH_TOKEN_FAILED,
      payload: error,
    });
  }
};
